import { gql } from "apollo-boost"

export const USER_LOGIN = gql`
mutation Login($data: LoginInput!) {
    login(data: $data) {
      accessToken
      data {
        id
        userAuthId
        firstName
        username
        nickname
        lastName
        gender
        phone
        role
        address {
          village
          district
          province
        }
        shop {
          id
          name
          isPaymentGateway
          address {
            village
            province
            district
          }
          image
          phone
          phoneSeconde
          desc
        }
      }
    }
  }



`

export const USER_LOGIN_V2 = gql`
  mutation LoginV2($data: LoginInput!) {
    loginV2(data: $data) {
      status
      msg
      tag
      code
      data {
        accessToken
        refreshToken
        data {
          id
          nickname
          phone
          fbId
          voidIp
          firstName
          lastName
          image
          address {
            province
            district
            village
          }
          coverImages
          fbToken
          appleUserId
          fbTokenExpire
          mobileToken
          platform
          uid
          role
          permission {
            id
            name
            note
            permissions
            isDeleted
            createdBy
            updatedBy
            createdAt
            updatedAt
            message
          }
          gender
          shop {
            name
            phone
            id
            address {
              province
              district
              village
            }
            image
            phone
            phoneSeconde
            desc
            isPaymentGateway
          }
          isVerified
          maritualStatus
          userSub
          email
          isOtp
          isConfirmed
          username
          createdAt
          updatedAt
          userAuthId
          staffCode
          userCode
        }
      }
    }
  }
`